import { camelCase } from 'lodash';

export const camelCaseKeys = (obj: unknown): unknown => {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) return obj.map(camelCaseKeys);

  return Object.fromEntries(
    Object.entries(obj as Record<string, unknown>).map(([k, v]) => [
      camelCase(k),
      camelCaseKeys(v),
    ])
  );
};
